import { Component, OnInit, OnDestroy } from '@angular/core';
import { BaseHttpService } from 'src/app/shared/services/basehttp.service';
import { NotificationService } from 'src/app/shared/services/notifications.service';
import { CardModel } from 'src/app/shared/components/view/card/card.model';
import { Constants } from 'src/app/shared/constants';
import { MockData } from '../main/main.model';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { LogoutServive } from "../logout/logout.service";
//import { url } from 'inspector';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
,  standalone: false
})

export class MainComponent {
  constant: Constants = new Constants();
  UserLoggedIn: boolean = false;
  constructor(private router: Router, private authService: AuthService, private logoutservice: LogoutServive) {
  }
  ngOnInit() {
    if (this.authService.isTokenValid()) {
      this.router.navigate(["/dashboard"]);
      this.UserLoggedIn = true;
      this.logoutservice.changeMessage(this.UserLoggedIn);
      return;
    }
    else {
      this.logoutservice.changeMessage(this.UserLoggedIn);
      this.router.navigate([""]);
    }
   
    //Mock Data
    //let i1 =
    //{
    //  id: "1",
    //  cardTitle: "Card1",
    //  cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
    //  isFavourite: true,
    //  surveyResults: "160 results",
    //  status: "S",
    //  accessLevel: ""
    //};
    //let i2 = {
    //  id: "2",
    //  cardTitle: "Card2",
    //  cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
    //  isFavourite: true,
    //  surveyResults: "150 results",
    //  status: "S",
    //  accessLevel: ""
    //};
    //let i3 = {
    //  id: "3",
    //  cardTitle: "Card3",
    //  cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
    //  isFavourite: true,
    //  surveyResults: "120 results",
    //  status: "S",
    //  accessLevel: ""
    //};
    //let i4 = {
    //  id: "4",
    //  cardTitle: "Card4",
    //  cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
    //  isFavourite: true,
    //  surveyResults: "100 results",
    //  status: "S",
    //  accessLevel: ""
    //};
    //let i5 = {
    //  id: "5",
    //  cardTitle: "Card5",
    //  cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
    //  isFavourite: true,
    //  surveyResults: "100 results",
    //  status: "S",
    //  accessLevel: ""
    //};

    //this.cards.push(i1, i2, i3, i4, i5);

    //var card = this.model.getMock("/favcards"); 
  }
  NavigateLogIn() {
    this.router.navigate(['/', 'login'])
  }
  NavigateRegister() {
    this.router.navigate(['/', 'register'])
  }
 

}

